<template>
    <span v-if="item">
        <template v-if="val">
            <span v-if="((item.userEmail==val || item.hdEmail==val) && item.linkedCount!=null)" class="text-warning">
                ({{item.linkedCount}})&nbsp;
            </span>
            <a href="javascript:void(0);" class="text-primary" v-clipboard:copy="val"
                v-clipboard:success="onCopy">{{val}}</a>
            &nbsp;

            <template v-if="item.hdLoginUrl==val">
                <a href="javascript:void(0);" class="text-warning" v-clipboard:copy="item.hdToken"
                    v-clipboard:success="onCopy"><i class="fa fa-key"></i></a>
            </template>
            <template v-if="item.devOpsUrl==val">
                <a href="javascript:void(0);" class="text-warning" v-clipboard:copy="item.devOpsToken"
                    v-clipboard:success="onCopy"><i class="fa fa-key"></i></a>
            </template>
            <template v-if="item.githubUrl == val">
                <a href="javascript:void(0);" class="text-warning" v-clipboard:copy="item.githubToken"
                    v-clipboard:success="onCopy"><i class="fa fa-key"></i></a>
            </template>
        </template>
    </span>
</template>
<style scoped>
    
</style>
<script>
import Vue from "vue";
import CommonFactory from '@/mixins/common.factory';
export default Vue.extend({
    mixins:[CommonFactory],
    data() {
        return {
            type:'',
            val:null,
            item:null
        }
    },
    created(){
        let _self=this;
        _self.val=_self.params.value;
        _self.item=_self.params.data;
    },
    methods:{
        onCopy(e){
            this.userMsg={show:true,type:'info',list:['You just copied: ' + e.text]};
        },
        copyVal(){

        },
        copyToken(){
            const _self=this;
            _self.params.data.type=_self.type;
            _self.params.context.componentParent.extraCallBackFn5(_self.params);
        }
    }
});
</script>
